module.exports = __webpack_public_path__ + "static/img/draw-title.a6e809b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draw-title.png
// module id = IoWR
// module chunks = 0